import featureFlagReducer from 'pollworker/src/state/featureFlag';
import { currentCustomerReducer } from 'pollworker/src/state/reducers/currentCustomer';
import { currentPollworkerUserReducer } from 'pollworker/src/state/reducers/currentUser';
import electionReducer from 'pollworker/src/state/reducers/election';
import scheduleReducer from 'pollworker/src/state/schedule';
import timeclockReducer from 'pollworker/src/state/timeclock';
import trainingReducer from 'pollworker/src/state/training';
import type { CookieAlert, PollworkerPublicCustomer, PollworkerPublicUser } from 'pollworker/src/types';
import { combineReducers } from 'redux';

export type PollworkerPublicState = {
  electionId: string;
  election: {
    electionId: string;
    elections: { Id: string; ElectionName: string }[] | null;
    loading: boolean;
  };
  workScheduleId: string;
  currentPollworkerUser: PollworkerPublicUser;
  currentCustomer: PollworkerPublicCustomer;
  cookieAlert: CookieAlert;
};

export default combineReducers({
  currentCustomer: currentCustomerReducer,
  currentPollworkerUser: currentPollworkerUserReducer,
  election: electionReducer,
  featureFlags: featureFlagReducer,
  schedule: scheduleReducer,
  timeclock: timeclockReducer,
  training: trainingReducer,
});
